/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Space_File_Restore_TitleInputs */



/**
* | output |
* | --- |
* | "Restore an earlier version of a file" |
*
* @param {Chat_Space_File_Restore_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_space_file_restore_title = /** @type {((inputs?: Chat_Space_File_Restore_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Space_File_Restore_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine frühere Fassung einer Datei wiederherstellen")
	return /** @type {LocalizedString} */ ("Restore an earlier version of a file")
});